import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { SelectOption } from '@kep-ui-kit/ui-components';

import {
  StyledFormGroup,
  StyledInput,
  StyledSelectMenu,
} from '@selfserve/react-ui';

import { AddOnItem, PlanItemInfo } from '../data';
import { FormValues } from '../feature/plans-overview';

interface Props {
  isAddOn: boolean;
  addonOptions: Array<SelectOption>;
  planOptions: Array<SelectOption>;
  setId: (id: string) => void;
  selectedItem?: PlanItemInfo | AddOnItem;
  formik: FormikProps<FormValues>;
}

export const UpdateFields = ({
  isAddOn,
  addonOptions,
  planOptions,
  selectedItem,
  setId,
  formik: { handleBlur, handleChange, values, touched, errors },
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledFormGroup>
        <StyledInput
          multiline
          autoFocus
          rows={3}
          name="extendedInfo"
          inputLabel={
            isAddOn ? t('common.addon-changes') : t('common.plan-changes')
          }
          error={touched.extendedInfo ? !!errors.extendedInfo : false}
          value={values.extendedInfo}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </StyledFormGroup>
      <StyledFormGroup largeMargin>
        <StyledSelectMenu
          fullWidth
          options={isAddOn ? addonOptions : planOptions}
          name="reason"
          inputLabel={isAddOn ? t('common.what-addon') : t('common.what-plan')}
          defaultValue={
            (selectedItem as AddOnItem)?.name || (selectedItem as PlanItemInfo)?.id
          }
          onChange={setId}
          onBlur={handleBlur}
        />
      </StyledFormGroup>
    </>
  );
};
